// services/vehicleSelected.js
import API_BASE from "../config/api";
export const fetchVehicleSelectedList = async (type = 2) => {
  
  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_BASE}/Vehicle/List?type=${type}`,
    {
      method: "GET",
  headers: {
      "Content-Type": "application/json",
      "Access-Token": token
    }
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch vehicle selected");
  }

  return await response.json();
};